import { periodLabel, usePeriod } from './PeriodContext';
import { formatDate } from '@/lib/money';

/**
 * Selo que mostra, DENTRO da tela, qual período está sendo consultado.
 *
 * O seletor fica na barra superior, longe dos números. Sem este selo, um
 * relatório impresso ou uma tela fotografada não dizem de que mês são — e um
 * total sem período é um número sem significado.
 */
export function PeriodBadge({ className = '' }: { className?: string }) {
  const { period } = usePeriod();

  // Mesma estrutura de `Field` (rótulo em cima, controle embaixo, sem padding
  // extra) para alinhar no rodapé quando fica lado a lado com os outros filtros.
  return (
    <div className={`block ${className}`}>
      <span className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">
        Período
      </span>
      <span
        className="block rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-2 text-sm dark:border-slate-700 dark:bg-slate-800"
        title="Alterar no seletor da barra superior"
      >
        {periodLabel(period)}
        <span className="ml-1.5 text-xs text-slate-400">
          {formatDate(period.from)} a {formatDate(period.to)}
        </span>
      </span>
    </div>
  );
}
